import axios from "axios"
import { REGIMEN_FISCAL_ENDPOINT } from "../../../../../../utility/SourceAPI"


export const fetchTaxRegimes = async () => {
    const response = await axios.get(REGIMEN_FISCAL_ENDPOINT)
    return response.data
}